/*
  Not fully migrated, this is here to support the footer migration.
  Please check and migrate correctly
*/

import type { RouteRecordRaw } from 'vue-router'

export const HELP_CENTER = {
  HOME: 'help_center',
}

const routes: RouteRecordRaw[] = [
  {
    name: HELP_CENTER.HOME,
    path: '/:locale/help',
    component: () => import('./Home.vue'),
    meta: {
      auth: {
        required: false,
      },
      layout: false,
      disableClientSideNavigation: () => true,
    },
  },
]

export default routes
